<div class="background opaque"></div>

<div class="background" style="z-index:100001">
    <ng-lottie class="lottie" [options]="loaderAnimation"></ng-lottie>
</div>